import { ADOBE_BACK_IN_STOCK_IMPRESSION_KEY } from "../../../../../../services/analytics/constants";
import { shouldShowNotifyMe } from "../../../../backInStock/selectors";

const getUpdateItemEvent = ({
  isVariantInStock,
  isOptedInToBackInStockNotifications
}) => {
  if (
    shouldShowNotifyMe({
      isProductInStock: true,
      isVariantInStock
    }) &&
    !isOptedInToBackInStockNotifications
  ) {
    return [ADOBE_BACK_IN_STOCK_IMPRESSION_KEY];
  }

  return [];
};

export default getUpdateItemEvent;
